import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { getApiDataService } from "../../../services/apiServices";
import { REGION_API } from "../../../services/CONSTANTS";
import { PAYMENT_TYPES } from "../../../config/AppConfig";

function CreatePaymentProviderModal(props) {
  // Initialize state with default values for accountName, accountNo, and status
  const [name, setName] = useState(null);
  const [paymentType, setPaymentType] = useState(null);
  const [regionId, setRegionId] = useState(null);
  const [logo, setLogo] = useState(null);
  const [preview, setPreview] = useState(null);

  const [regions, setRegions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchRegions();
  }, []);

  const fetchRegions = () => {
    setIsLoading(true);
    getApiDataService(REGION_API + "?status=active")
      .then((response) => {
        setRegions(response.data);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const handleNameChange = (event) => {
    setName(event.target.value);
  };
  const handlePaymentTypeChange = (event) => {
    setPaymentType(event.target.value);
  };
  const handleRegionChange = (event) => {
    setRegionId(event.target.value);
  };
  const handleLogoChange = (e) => {
    // setLogo(event.target.value);
    if (
      e.target.files[0].type === "image/jpeg" ||
      e.target.files[0].type === "image/png" ||
      e.target.files[0].type === "image/jpg"
    ) {
      let imgReview = e.target.files[0];
      console.log(imgReview);
      if (imgReview) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreview(reader.result);
        };
        reader.readAsDataURL(imgReview);
      } else {
        setPreview(null);
      }
      setLogo(e.target.files[0]);
    } else {
      alert("This is only accept image files! Thanks");
      setLogo(null);
      return;
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);
    let form_data = new FormData();
    form_data.append("name", name);
    form_data.append("payment_type", paymentType);
    form_data.append("region_id", regionId);
    form_data.append("logo", logo);
    props.onSubmit(form_data);
  };

  return (
    <Modal isOpen={true} toggle={props.onClose}>
      <ModalHeader toggle={props.onClose}>
        <h4>Create Payment Provider</h4>
         </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="status">Region</Label>
            <Input type="select" name="region" onChange={handleRegionChange}>
              <option value="">Select Region</option>
              {regions.map((region) => {
                return <option value={region.id}>{region.country_name}</option>;
              })}
            </Input>
          </FormGroup>
          <FormGroup>
            <Label for="accountName">Name</Label>
            <Input type="text" name="accountName" id="accountName" onChange={handleNameChange} />
          </FormGroup>
          <FormGroup>
            <Label for="logo">Logo</Label>
            <Input
              type="file"
              accept="image/png, image/gif, image/jpeg"
              name="logo"
              id="logo"
              onChange={handleLogoChange}
            />
          </FormGroup>
          {preview && <img src={preview} alt="" style={{ width: "100px", height: "100px" }} />}
          <FormGroup>
            <Label for="status">Type</Label>
            <Input type="select" name="paymentType" onChange={handlePaymentTypeChange}>
              <option value="">Select type</option>
              {PAYMENT_TYPES.map((paymentType) => {
                return <option value={paymentType}>{paymentType}</option>;
              })}
            </Input>
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <button className="btn btn-default" onClick={props.onClose}>
          No
        </button>
        {isLoading == false && (
          <button className="btn btn-success" onClick={handleSubmit}>
            Save
          </button>
        )}
        {isLoading == true && (
          <button className="btn btn-success" disabled="disabled">
            Uploading...
          </button>
        )}
      </ModalFooter>
    </Modal>
  );
}

export default CreatePaymentProviderModal;
